/* unplugin-vue-components disabled */import script from "./information.vue?vue&type=script&setup=true&lang=js"
export * from "./information.vue?vue&type=script&setup=true&lang=js"

import "./information.vue?vue&type=style&index=0&id=ab72db5c&lang=less&scoped=true"

import exportComponent from "E:\\work\\AirLink-html\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ab72db5c"]])

export default __exports__